

export default {
    totalRecords: 0,
    totalReferal: 0,
    referalList: []
}
